/**
 * Search input — text field with exact/any toggle and clear button.
 */

import { useRef, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { bibleState } from '@/state/bible-state';
import { CloseIcon } from '@components/icons';

export const SearchInput = observer(function SearchInput() {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div className="search-input-container">
      <div className="search-input-row">
        <input
          ref={inputRef}
          type="text"
          className="search-input"
          placeholder="Search or jump to a verse..."
          value={bibleState.searchText}
          onChange={(e) => bibleState.setSearchText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') bibleState.jumpToSearchReference();
          }}
        />
        {bibleState.searchText && (
          <button
            onClick={() => bibleState.clearSearch()}
            className="search-clear-btn"
            title="Clear search"
          >
            <CloseIcon className="h-4 w-4" />
          </button>
        )}
      </div>
      <div className="search-mode-toggle">
        <button
          onClick={() => bibleState.setSearchExact(false)}
          className={`search-mode-btn ${!bibleState.isSearchExact ? 'active' : ''}`}
        >
          Any Words
        </button>
        <button
          onClick={() => bibleState.setSearchExact(true)}
          className={`search-mode-btn ${bibleState.isSearchExact ? 'active' : ''}`}
        >
          Exact Phrase
        </button>
      </div>
    </div>
  );
});
